import moment from 'moment-timezone';

const titleBuilder = (extendedProps, defaultTitle, t) => {
  const {
    dateType,
    estimatedDailyHours,
    estimatedStartTime,
    estimatedEndTime,
    hasAssignments,
    status
  } = extendedProps;

  const formattedEstimatedStartDate = moment(
    estimatedStartTime,
    'HH:mm'
  ).format('h:mma');
  const formattedEstimatedEndDate = moment(estimatedEndTime, 'HH:mm').format(
    'h:mma'
  );

  // Determine if the event is editable based on status
  const isEditable = status === 'AVAILABLE' || status === 'UNAVAILABLE';

  const actionText = isEditable
    ? defaultTitle === 'Confirmed'
      ? t('CalendarRoute.tooltip.actionView')
      : t('CalendarRoute.tooltip.actionEdit')
    : t('CalendarRoute.tooltip.cannotEdit');

  const wrap = (primary, secondary) => (
    <div className="tailwind-root contents">
      <div className="flex flex-col items-center">
        <div className="text-[12px]">{primary}</div>
        <div className="text-[11px]">{secondary}</div>
      </div>
    </div>
  );

  if (hasAssignments) {
    return wrap(defaultTitle, t('CalendarRoute.tooltip.notEditable'));
  }

  switch (dateType) {
    case 'DEFAULT_RECURRING':
      return wrap(t('CalendarRoute.tooltip.availableAllDay'), actionText);
    case 'RECURRING_HOURS':
      return wrap(
        t('CalendarRoute.tooltip.availableForHours', {
          hours: estimatedDailyHours
        }),
        actionText
      );
    case 'RECURRING_SPECIFIC_HOURS':
      return wrap(
        t('CalendarRoute.tooltip.availableSpecificHours', {
          start: formattedEstimatedStartDate,
          end: formattedEstimatedEndDate
        }),
        actionText
      );
    default:
      return wrap(defaultTitle, actionText);
  }
};

export default titleBuilder;
